import React from "react";
import RootStore from "./RootStore";

export const storesContext = React.createContext<RootStore | null>(null);

export const useStores = () => {
  const rootStore = React.useContext(storesContext);
  if (rootStore == null) {
    throw new Error("No RootStore found in context");
  }
  return rootStore;
};
